import { render, staticRenderFns } from "./ProdutosDoPedido.vue?vue&type=template&id=7443bc48&scoped=true&"
import script from "./ProdutosDoPedido.vue?vue&type=script&lang=js&"
export * from "./ProdutosDoPedido.vue?vue&type=script&lang=js&"
import style0 from "./ProdutosDoPedido.vue?vue&type=style&index=0&id=7443bc48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7443bc48",
  null
  
)

export default component.exports